import React, {PureComponent} from 'react';
import {FastField, ErrorMessage} from 'formik';
import get from 'lodash/get';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import CommonFields from './CommonFields';
import FormRow from '../FormRow';
import Error from '../../../Error';
import ExternalProviderTester from './ExternalProviderTester';

class SingleChoice1ExtType extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {name, form, previousPages} = this.props;

        return (
            <>
                <CommonFields name={name} form={form} required={true} previousPages={previousPages} />
                <FormRow name={`${name}.url`} label={messages.surveys.form.label.url}>
                    <FastField id={`${name}.url`} name={`${name}.url`} type="url"
                        className={classNames('form-control',
                            {error: get(form.errors, `${name}.url`) && get(form.touched, `${name}.url`)})} />
                    <ErrorMessage name={`${name}.url`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </FormRow>
                <ExternalProviderTester values={get(form.values, name)}>
                    {(data) => <FormattedMessage {...messages.surveys.form.externalProviderTest.singleChoice1Ext}
                        values={{count: <strong>{data.length}</strong>}} />}
                </ExternalProviderTester>
            </>
        );
    }
}

export default SingleChoice1ExtType;
